import { useEffect } from "react";
import Mechanization from '../table/Tablemechanization';
import Modal from "../modal/Modaladdmechanization"



const Dashboard = () => {
  useEffect(() => {
    // getPromise(["sales", "purchases"]);
  }, []);


  return (
    <>
    <Modal/>
    <Mechanization/>
    
     
     </>
  );
};

export default Dashboard;
